<i class="fa fa-spinner app-loader" *ngIf="isLoading"></i> {{ label }}
